import * as types from './reports.types';

export const reportPageSelectors: types.IReportsPageSelectors = {
  selectMeetingReports: (state) => state.page.reports.byMeeting,
  selectMeetingReportByMeetingId: (state, meetingId) => state.page.reports.byMeeting[meetingId],
  selectUserReportByUserId: (state, userId) => state.page.reports.byUserGlobal[userId],
};
